/* Reminder Bids search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import { DateRanges } from '../common/dateranges';
import { OrderStatuses } from '../order/orderpricing';

export interface ISearchFiltersReminderBidsState {
    clientId: any;
    fromCompletionDate: string;
    fromReminderDate: string;
    fromSentDate: string;
    regionId: any;
    selectedOrderIds: any;
    statusId: any;
    toCompletionDate: string;
    toReminderDate: string;
    toSentDate: string;
    unsolicitedBid: any;
    serviceLevelId: any;
}

const defaultFromSentDateRangeValue = DateRanges.DateRangeOptionValues.LAST_THREE_YEARS;
// const defaultFromSentDateRangeValue = DateRanges.DateRangeOptionValues.LAST_THREE_MONTHS;

const initialState: ISearchFiltersReminderBidsState = {
    clientId: -1,
    fromCompletionDate: '',
    fromReminderDate: '',
    fromSentDate: DateRanges.getStartDate(defaultFromSentDateRangeValue),
    regionId: -1,
    selectedOrderIds: [],
    statusId: OrderStatuses.JOB_SENT_OR_WON_STATUSES,
    toCompletionDate: '',
    toReminderDate: '',
    toSentDate: '',
    unsolicitedBid: -1,
    serviceLevelId: -1,
};

export function searchFiltersReminderBidsReducer(state: ISearchFiltersReminderBidsState = initialState, action: any): ISearchFiltersReminderBidsState {
    switch (action.type) {
        case Actions.SEARCH_REMINDER_BIDS_CLIENT:
            return _.merge({}, state, { clientId: action.value });
        case Actions.SEARCH_REMINDER_BIDS_STATUS:
            return _.merge({}, state, { statusId: action.value });
        case Actions.SEARCH_REMINDER_BIDS_REGION:
            return _.merge({}, state, { regionId: action.value });
        case Actions.SEARCH_REMINDER_BIDS_UNSOLICITED_BID:
            return _.merge({}, state, { unsolicitedBid: action.value });
        case Actions.SEARCH_REMINDER_BIDS_SELECTED_ORDER_IDS:
            return _.merge({}, state, { selectedOrderIds: action.value });
        case Actions.SEARCH_REMINDER_BIDS_SERVICE_LEVEL:
            return _.merge({}, state, { serviceLevelId: action.value });

        // BID DATE FILTER
        // case Actions.SEARCH_REMINDER_BIDS_FROM_BID_DATE:
        //     return _.merge({}, state, { fromBidDate: action.value });
        // case Actions.SEARCH_REMINDER_BIDS_TO_BID_DATE:
        //     return _.merge({}, state, { toBidDate: action.value });

        // REMINDER DATE FILTER
        case Actions.SEARCH_REMINDER_BIDS_FROM_REMINDER_DATE:
            return _.merge({}, state, { fromReminderDate: action.value });
        case Actions.SEARCH_REMINDER_BIDS_TO_REMINDER_DATE:
            return _.merge({}, state, { toReminderDate: action.value });

        // FOLLOW UP DATE FILTER
        // case Actions.SEARCH_REMINDER_BIDS_FROM_FOLLOW_UP_DATE:
        //     return _.merge({}, state, { fromFollowUpDate: action.value });
        // case Actions.SEARCH_REMINDER_BIDS_TO_FOLLOW_UP_DATE:
        //     return _.merge({}, state, { toFollowUpDate: action.value });

        // COMPLETION DATE FILTER
        case Actions.SEARCH_REMINDER_BIDS_FROM_COMPLETION_DATE:
            return _.merge({}, state, { fromCompletionDate: action.value });
        case Actions.SEARCH_REMINDER_BIDS_TO_COMPLETION_DATE:
            return _.merge({}, state, { toCompletionDate: action.value });

        // SENT DATE FILTER
        case Actions.SEARCH_REMINDER_BIDS_FROM_SENT_DATE:
            return _.merge({}, state, { fromSentDate: action.value });
        case Actions.SEARCH_REMINDER_BIDS_TO_SENT_DATE:
            return _.merge({}, state, { toSentDate: action.value });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersReminderBidsReducer.tsx